export enum RegistrationStatus {
  closed = 'closed',
  pending = 'pending',
  in_progress = 'in_progress',
  payment_pending = 'payment_pending',
  registered = 'registered',
  shortlisted = 'shortlisted',
  rejected = 'rejected',

  // CEE Status
  cee_scheduled = 'cee_scheduled',
  cee_started = 'cee_started',
  cee_missed = 'cee_missed', // trigger only from backend
  cee_completed = 'cee_completed',
  cee_passed = 'cee_passed',
  cee_passed_excellence = 'cee_passed_excellence',
  cee_passed_lite = 'cee_passed_lite',
  cee_failed = 'cee_failed',

  // Direct Admission (Fast Track) Status
  da_scheduled = 'da_scheduled',
  da_started = 'da_started',
  da_completed = 'da_completed',
  da_passed_lite = 'da_passed_lite',
  da_passed_excellence = 'da_passed_excellence',
  da_failed = 'da_failed',

  // PI Status
  pi_waiting = 'pi_waiting',
  pi_scheduled = 'pi_scheduled',
  pi_cleared = 'pi_cleared',
  pi_not_cleared = 'pi_not_cleared',

  // Final Status
  final_result_waiting = 'final_result_waiting',
  final_result_declared = 'final_result_declared',
  //   final_result_cleared = 'final_result_cleared',
  final_result_not_cleared = 'final_result_not_cleared',

  // Admission Fee
  admission_fee_pending = 'admission_fee_pending',
  admission_fee_paid = 'admission_fee_paid',

  // Additional Details
  additional_details = 'additional_details',

  // Semester Fee
  semester_fee = 'semester_fee',
}

export enum WHO_ARE_YOU {
  Student = 'Student',
  Guardian = 'Guardian',
}

export enum CounsellingPreference {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}
